import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-slate-900 text-white overflow-hidden" data-id="element-84">
      {/* Abstract Ocean Background */}
      <div className="absolute inset-0 z-0 opacity-20" data-id="element-85">
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900 to-blue-900/50" data-id="element-86" />
        <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-87">
          <path d="M0 50 Q 25 40 50 50 T 100 50 V 100 H 0 Z" fill="currentColor" className="text-blue-800" data-id="element-88" />
          <path d="M0 60 Q 25 50 50 60 T 100 60 V 100 H 0 Z" fill="currentColor" className="text-blue-700" data-id="element-89" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 lg:py-40" data-id="element-90">
        <div className="max-w-3xl" data-id="element-91">
          <div className="inline-flex items-center px-3 py-1 rounded-full border border-teal-500/30 bg-teal-500/10 text-teal-400 text-sm font-medium mb-6" data-id="element-92">
            <span className="flex h-2 w-2 rounded-full bg-teal-400 mr-2" data-id="element-93"></span>
            Premium Quality Seafood in Kaduna
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6 leading-tight" data-id="element-94">
            Freshness You Can Trust, <br data-id="element-95" />
            <span className="text-teal-400" data-id="element-96">Quality You Can Taste.</span>
          </h1>

          <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-2xl leading-relaxed" data-id="element-97">
            Gauchos Frozen Food is your premier supplier of high-quality frozen
            seafood. Serving restaurants, caterers, and households in Kaduna
            with reliability and excellence.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-98">
            <a href="tel:08035856111" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-slate-900 bg-teal-400 hover:bg-teal-300 transition-colors duration-200" data-id="element-99">
              <Phone className="mr-2 h-5 w-5" data-id="element-100" />
              Call 0803 585 6111
            </a>
            <a href="#contact" className="inline-flex items-center justify-center px-6 py-3 border border-slate-600 text-base font-medium rounded-lg text-white hover:bg-slate-800 transition-colors duration-200" data-id="element-101">
              Visit Our Store
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-102" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}